// Copyright (c) 2016 Deere & Company

import './pip-history-item.scss';
import React, {PropTypes} from 'react';
import PipHistory from '@deere/cps-it.warranty-model-factory/lib/pip-history';
import PipHistoryItemDetails from './pip-history-item-details';
import PipHistoryItemHeader from './pip-history-item-header';

const PipHistoryItem = props =>

    <section className='pip-history-item'>

        <PipHistoryItemHeader
            pin={props.pin}
            pip={props.pip}
        />

        <PipHistoryItemDetails pip={props.pip}/>

    </section>;

PipHistoryItem.displayName = 'PipHistoryItem';
PipHistoryItem.propTypes = {
    pin: PropTypes.string.isRequired,
    pip: PropTypes.instanceOf(PipHistory).isRequired
};

export default PipHistoryItem;



// WEBPACK FOOTER //
// ./src/product/details/components/pip-history-item.js